import PropTypes from 'prop-types';
import React from 'react';
import T from 'components/T';
import {
  ReportTable,
  ReportTableBody,
  ReportTableCell,
  ReportTableHead,
  ReportTableRow,
  ReportTableRowLabel,
} from 'components/Reports/Report/MastodonReport/ReportTable';
import EducationTableTitle from './EducationTableTitle';

const CandidateInput = ({ school }) => (
  <ReportTable small>
    <ReportTableHead>
      <ReportTableRow>
        <EducationTableTitle>
          <T value='components.education.candidateInput' />
        </EducationTableTitle>
      </ReportTableRow>
    </ReportTableHead>

    <ReportTableBody>
      <ReportTableRow>
        <ReportTableRowLabel className='text-very-muted column-6'>
          <T value='components.education.degree' />
        </ReportTableRowLabel>
        <ReportTableCell className='column-6'>
          {school.degree || '-'}
        </ReportTableCell>
      </ReportTableRow>
      <ReportTableRow>
        <ReportTableRowLabel className='text-very-muted column-6'>
          <T value='components.education.major' />
        </ReportTableRowLabel>
        <ReportTableCell className='column-6'>
          {school.major || '-'}
        </ReportTableCell>
      </ReportTableRow>
    </ReportTableBody>
  </ReportTable>
);

CandidateInput.propTypes = {
  school: PropTypes.object.isRequired,
};

export default CandidateInput;
